import React from "react";

export const Arrow = ({ rotate = 0 }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <path
        d="M17.7732 10.3941C18.0775 10.0732 18.0753 9.55516 17.7683 9.23706C17.4613 8.91897 16.9658 8.92128 16.6615 9.24223L14.8383 11.1655C14.0983 11.946 13.589 12.4814 13.1575 12.8437C12.7384 13.1956 12.4691 13.3164 12.228 13.3485C12.0766 13.3687 11.9234 13.3687 11.772 13.3485C11.5309 13.3164 11.2616 13.1956 10.8425 12.8437C10.411 12.4814 9.90171 11.946 9.16174 11.1655L7.33846 9.24223C7.0342 8.92129 6.53868 8.91897 6.2317 9.23707C5.92471 9.55516 5.9225 10.0732 6.22676 10.3941L8.08288 12.352C8.78195 13.0894 9.35331 13.6922 9.86239 14.1196C10.3918 14.564 10.9291 14.8858 11.5741 14.9717C11.8569 15.0094 12.1431 15.0094 12.4259 14.9717C13.0709 14.8858 13.6082 14.564 14.1376 14.1196C14.6467 13.6921 15.218 13.0895 15.9171 12.352L17.7732 10.3941Z"
        fill="#6C6E70"
      />
    </svg>
  );
};
